import React, { useEffect } from 'react';
import './App.css';
import Toolbar from './components/Toolbar';
import GraphEditor from './components/GraphEditor';
import DialogueEditor from './components/DialogueEditor';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ToastProvider } from './contexts/ToastContext';
import { usePersistenceStore } from './store/persistenceStore';
import { useAutoSave } from './hooks/useAutoSave';
import { useToast } from './contexts/ToastContext';

function AppContent() {
  const { isAuthenticated, authenticate, error } = usePersistenceStore();
  const { toast } = useToast();
  useAutoSave(30000); // Auto-save every 30 seconds

  useEffect(() => {
    // Auto-authenticate when not authenticated
    if (!isAuthenticated) {
      authenticate().catch(err => {
        console.error('Authentication failed:', err);
      });
    }
  }, [isAuthenticated, authenticate]);

  useEffect(() => {
    if (error) {
      toast({
        title: 'Error',
        description: error,
        variant: 'error'
      });
    }
  }, [error, toast]);

  return (
    <div className="App h-screen flex flex-col bg-gray-50 dark:bg-gray-900 transition-colors duration-200">
      <Toolbar />
      <div className="flex-1 flex overflow-hidden">
        <div className="flex-1 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
          <ErrorBoundary>
            <GraphEditor />
          </ErrorBoundary>
        </div>
        <div className="w-96 bg-gray-50 dark:bg-gray-900 overflow-y-auto">
          <ErrorBoundary>
            <DialogueEditor />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </ErrorBoundary>
  );
}

export default App;
